import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageMeta } from "@/components/site/PageMeta";
import { AssessmentShell, ChoiceQuestion } from "@/components/built-index/AssessmentShell";
import { BUILT_INDEX_ROUTES, LOVE_QUESTIONS } from "@/content/built-index";
import { readSession, writeSession } from "@/lib/built-index-session";
import { trackBuiltIndexStep } from "@/lib/built-index-analytics";

const BuiltIndexFuelDrain = () => {
  const navigate = useNavigate();
  const [answers, setAnswers] = useState<Record<string, string>>({});

  useEffect(() => {
    const s = readSession();
    if (!s.id) {
      navigate(BUILT_INDEX_ROUTES.start, { replace: true });
      return;
    }
    setAnswers(s.love);
  }, [navigate]);

  const set = (id: string, value: string) => {
    const next = { ...answers, [id]: value };
    setAnswers(next);
    writeSession({ love: next });
  };

  const answered = LOVE_QUESTIONS.filter((q) => answers[q.id]).length;

  return (
    <>
      <PageMeta
        title="Fuel & Drain · The Built Index"
        description="Find what refuels your leadership and what quietly burns you out."
        path="/built-index/fuel-drain"
        noindex
      />
      <AssessmentShell
        step={3}
        title="Fuel &amp; Drain"
        intro="What refills a leader is not the same as what impresses one. Answer for the version of you at the end of a hard week."
        footer={
          <div className="flex items-center justify-between gap-4 flex-wrap">
            <span className="text-silver text-xs uppercase tracking-[0.2em]">
              {answered} of {LOVE_QUESTIONS.length} answered
            </span>
            <button
              type="button"
              disabled={answered !== LOVE_QUESTIONS.length}
              onClick={() => {
                trackBuiltIndexStep("assessment_love", {
                  sessionId: readSession().id,
                  email: readSession().email,
                  metadata: { answered },
                });
                navigate(BUILT_INDEX_ROUTES.lovin);
              }}
              className="inline-flex items-center gap-2 bg-orange text-primary-foreground px-6 py-3 text-xs uppercase tracking-[0.2em] font-semibold hover:brightness-110 transition disabled:opacity-50"
            >
              Continue to Listening Scale <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        }
      >
        {LOVE_QUESTIONS.map((q, i) => (
          <ChoiceQuestion
            key={q.id}
            id={q.id}
            index={i + 1}
            prompt={q.prompt}
            options={q.options as unknown as Record<string, string>}
            value={answers[q.id]}
            onChange={(v) => set(q.id, v)}
          />
        ))}
      </AssessmentShell>
    </>
  );
};

export default BuiltIndexFuelDrain;
